import React, { useState, useEffect } from "react";
import { getOptionsData } from "../../utils/app.utils";
import { useQuery } from "@tanstack/react-query";
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
} from "@mui/material";

export default function MultipleChoice({
  question,
  value = [],
  onChange,
}: any) {
  const [selected, setSelected] = useState(Array.isArray(value) ? value : []);
  const [options, setOptions] = useState<any[]>([]);

  const { data: optionsData = [], isLoading } = useQuery({
    queryKey: ["options", question?.id],
    queryFn: () => getOptionsData(question?.id),
  });

  useEffect(() => {
    if (optionsData.length) {
      setOptions(optionsData);
    }
  }, [optionsData]);

  const handleChange = (id: any) => {
    let newSelected;
    if (selected.includes(id)) {
      newSelected = selected.filter((x) => x !== id);
    } else {
      newSelected = [...selected, id];
    }
    setSelected(newSelected);
    onChange?.(newSelected);
  };

  return (
    <FormGroup>
      {options.map((opt: any) => (
        <FormControlLabel
          key={opt.id}
          control={
            <Checkbox
              checked={selected.includes(opt.id)}
              onChange={() => handleChange(opt.id)}
              sx={{ transform: "scale(1)" }}
            />
          }
          label={<Typography sx={{ fontSize: "1rem" }}>{opt.name}</Typography>}
        />
      ))}
    </FormGroup>
  );
}
